/**
 * silentRefresh.js
 *
 * Background-refresh helper. Schedules a single `setTimeout` that
 * fires 60 seconds before the access/id-token expires. Cancels any
 * previously scheduled timer so we never have two queued at once.
 */

let timer = null;

export function scheduleRefresh(expiresAtMs, refreshFn) {
  cancelRefresh();
  if (typeof refreshFn !== 'function') return;
  // Refresh 60s before expiry, but never schedule a negative delay.
  const delay = Math.max(0, expiresAtMs - Date.now() - 60_000);
  timer = setTimeout(() => {
    timer = null;
    Promise.resolve()
      .then(refreshFn)
      .catch((err) => console.error('[auth] silent refresh failed:', err));
  }, delay);
}

export function cancelRefresh() {
  if (timer) {
    clearTimeout(timer);
    timer = null;
  }
}
